var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseTable from '@/components/base/BaseTable.vue';
import TableMixin from '@/mixins/table-mixin';
import SteppedPageMixin from '@/mixins/stepped-page-mixin';
import { TYPES } from '@/dependency-injection/types';
import { ValidationObserver } from 'vee-validate';
import ValidatedTextField from '@/components/shared/ValidatedTextField.vue';
import ValidatedTextarea from '@/components/shared/ValidatedTextarea.vue';
import ValidatedAutocomplete from '@/components/shared/ValidatedAutocomplete.vue';
import ValidatedCheckbox from '@/components/shared/ValidatedCheckbox.vue';
import DatePicker from '@/components/shared/DatePicker.vue';
import * as getDate from 'date-fns/get_date';
import * as format from 'date-fns/format';
import * as addWeeks from 'date-fns/add_weeks';
import * as addMonths from 'date-fns/add_months';
import * as setDay from 'date-fns/set_day';
import * as isBefore from 'date-fns/is_before';
var AdditionalAllocationPeriodsTable = /** @class */ (function (_super) {
    __extends(AdditionalAllocationPeriodsTable, _super);
    function AdditionalAllocationPeriodsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.headers = [
            { text: 'Period', value: 'period', width: '20%' },
            { text: 'Week Start Day', value: 'weekStartDay', width: '20%' },
            { text: 'Repeat(s) On', width: '30%' },
            { text: 'Next Cycle Begin(s) On', width: '20%' },
            { text: 'Actions', sortable: false, width: '10%' },
        ];
        return _this;
    }
    AdditionalAllocationPeriodsTable.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.ContractManagementService;
    };
    AdditionalAllocationPeriodsTable.prototype.openSidesheet = function (item, mode) {
        var contractManagementService = this.service;
        // add the contract id to the default pricing formula
        var data = item
            ? __assign({}, item)
            : contractManagementService.getDefaultAdditionalAllocationPeriod();
        data.contractId = this.contractId;
        this.openCrudSidesheet(data, mode);
    };
    AdditionalAllocationPeriodsTable.prototype.getNextDate = function (item) {
        if (item.period === '5 DAYS') {
            var month = format(new Date(), 'MMMM');
            var date = getDate(new Date());
            if (date < 6) {
                return month + " 6th";
            }
            if (date < 11) {
                return month + " 11th";
            }
            if (date < 16) {
                return month + " 16th";
            }
            if (date < 21) {
                return month + " 21st";
            }
            if (date < 26) {
                return month + " 26th";
            }
            return format(addMonths(new Date(), 1), 'MMMM') + " 1st";
        }
        else if (item.period === '10 DAYS') {
            var month = format(new Date(), 'MMMM');
            var date = getDate(new Date());
            if (date < 11) {
                return month + " 11th";
            }
            if (date < 21) {
                return month + " 21st";
            }
            return format(addMonths(new Date(), 1), 'MMMM') + " 1st";
        }
        else if (item.period === 'WEEKLY') {
            // get the day of the week as a number
            var dayOfWeek = 0;
            if (item.weekStartDay === 'MONDAY') {
                dayOfWeek = 1;
            }
            if (item.weekStartDay === 'TUESDAY') {
                dayOfWeek = 2;
            }
            if (item.weekStartDay === 'WEDNESDAY') {
                dayOfWeek = 3;
            }
            if (item.weekStartDay === 'THURSDAY') {
                dayOfWeek = 4;
            }
            if (item.weekStartDay === 'FRIDAY') {
                dayOfWeek = 5;
            }
            if (item.weekStartDay === 'SATURDAY') {
                dayOfWeek = 6;
            }
            if (item.weekStartDay === 'SUNDAY') {
                dayOfWeek = 7;
            }
            // set the date to the nearest day of the week
            var date = setDay(new Date(), dayOfWeek);
            if (isBefore(date, new Date())) {
                return format(addWeeks(date, 1), 'MMMM Do');
            }
            else {
                return format(date, 'MMMM Do');
            }
        }
    };
    Object.defineProperty(AdditionalAllocationPeriodsTable.prototype, "additionalAllocationPeriods", {
        get: function () {
            var allocationPeriods = this.item.allocationPeriods;
            return allocationPeriods;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Number, required: true }),
        __metadata("design:type", Number)
    ], AdditionalAllocationPeriodsTable.prototype, "contractId", void 0);
    AdditionalAllocationPeriodsTable = __decorate([
        Component({
            components: {
                'validation-observer': ValidationObserver,
                'validated-text-field': ValidatedTextField,
                'validated-text-area': ValidatedTextarea,
                'validated-autocomplete': ValidatedAutocomplete,
                'validated-checkbox': ValidatedCheckbox,
                'date-picker': DatePicker,
                'base-table': BaseTable,
            },
        })
    ], AdditionalAllocationPeriodsTable);
    return AdditionalAllocationPeriodsTable;
}(Mixins(TableMixin, SteppedPageMixin)));
export default AdditionalAllocationPeriodsTable;
